export var createSDKQueue = function createSDKQueue() {
  var q = function CMSQueue() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    q.__q__.push(args);
  };
  q.__q__ = [];
  return q;
};